'use client';

import { useTranslations } from 'next-intl';
import { useState, useEffect } from 'react';

import { FeatureProductInfoMain } from '@/fo/feature/product/info/main';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';
import { UiKitLabelBrand } from '@/fo/ui/kit/label/brand';
import { utilEventConfigurableProduct } from '@/fo/util/event-configurable-product';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './FeatureProductModalConfig.styles';

export interface FeatureProductModalConfigProps {
  isAuthorized: boolean;
}

export function FeatureProductModalConfig({
  isAuthorized
}: FeatureProductModalConfigProps) {
  const slots = styles();
  const t = useTranslations();

  const [open, setOpen] = useState(false);

  const [product, setProduct] = useState<MappedProduct | null>(null);

  useEffect(() => {
    const unsubscribeOnOpen = utilEventConfigurableProduct.onOpen((product) => {
      const selectedOption = product.configurableVariants?.find(
        (item) => item.stockStatus === 'IN_STOCK'
      );

      const selectedProduct = selectedOption?.product;

      setProduct(
        selectedProduct
          ? {
              ...selectedProduct,
              parentSku: product.parentSku,
              configurableVariants: product.configurableVariants?.map(
                (variant) => ({
                  ...variant,
                  isSelected:
                    selectedOption !== undefined &&
                    variant.sku === selectedOption.sku
                })
              )
            }
          : product
      );

      setOpen(true);
    });
    const unsubscribeOnClose = utilEventConfigurableProduct.onClose(() =>
      setOpen(false)
    );
    const unsubscribeOnProductSelect =
      utilEventConfigurableProduct.onProductSelect((updatedProduct) => {
        setProduct(updatedProduct);
      });

    return () => {
      unsubscribeOnOpen();
      unsubscribeOnClose();
      unsubscribeOnProductSelect();
    };
  }, []);

  const maxCount = product?.stockQuantity || 0;

  return (
    <UiKitDrawerBase
      title={t('product.configurable.selectVolume')}
      open={open}
      direction="right"
      onOpenChange={setOpen}
    >
      <div className={slots.title()}>
        {t('product.configurable.selectVolume')}
      </div>

      {product && (
        <FeatureProductInfoMain
          isAuthorized={isAuthorized}
          listName="preview"
          type="catalog"
          labels={
            product.labelsBrand.length
              ? product.labelsBrand.map(({ name, color, url }) => (
                  <UiKitLabelBrand
                    key={name}
                    url={url}
                    color={color}
                  >
                    {name}
                  </UiKitLabelBrand>
                ))
              : null
          }
          maxStockQuantity={maxCount}
          product={product}
        />
      )}
    </UiKitDrawerBase>
  );
}
